import React, { useState } from 'react';

export default function TextForm(props) {
    const [text, setText] = useState("");
    const [result, setResult] = useState('');
    const makeUpCase = () => {
        let newText = text.toUpperCase();
        setResult(newText);
        if (text.length !== 0) {
            props.showAlert("Converted to uppercase", "success");
        }else{
            props.showAlert("Enter Some Letter first", "danger");
        }
    }

    const makeLwCase = () => {
        let newText = text.toLowerCase();
        setResult(newText);
        if (text.length !== 0) {
            props.showAlert("Converted to lowercase", "success");
        }else{
            props.showAlert("Enter Some Letter first", "danger");
        }
    }

    const makeCapitalize = () => {
        let newText = text.split(". ").map(sentence => sentence.charAt(0).toUpperCase() + sentence.slice(1).toLowerCase()).join(". ");
        setResult(newText);
        if (text.length !== 0) {
            props.showAlert("Sentences are capitalized", "success");
        }else{
            props.showAlert("Enter Some Letter first", "danger");
        }
    }

    const noOfWords = () => {
        let wordCount = text.trim().split(/\s+/).length;
        setResult(wordCount.toString());
        if (text.length !== 0) {
            props.showAlert("Words are counted", "success");
        }else{
            props.showAlert("Enter Some Letter first", "danger");
        }
    }

    const clsScreen = () => {
        setText('');
        setResult('');
        if (text.length !== 0) {
            props.showAlert("All text cleared", "success");
        }else{
            props.showAlert("There is Nothing to clear", "danger");
        }
    }

    const OnChange = (event) => {
        setText(event.target.value);
        setResult(event.target.value);
    }

    const cpText = () => {
        navigator.clipboard.writeText(result);
        if (text.length !== 0) {
            props.showAlert("Text copied to clipboard", "success");
        }else{
            props.showAlert("There Are no Letter To Copy", "danger");
        }
    }

    const rmExtraSpace = () => {
        let newText = text.split(/[ ]+/).join(" ");
        setResult(newText);
        if (text.length !== 0) {
            props.showAlert("Extra spaces removed", "success");
        }else{
            props.showAlert("Enter Some Letter first", "danger");
        }
    }

    const dwText = () => {
        const file = new Blob([result], { type: "text/plain" });
        const dlink = document.createElement('a');
        dlink.href = URL.createObjectURL(file);
        dlink.download = 'textbybiswajit-' + Date.now() + '.txt';
        document.body.appendChild(dlink);
        dlink.click();
    }

    return (
        <>
            <div className= {`row mt-3 `}>
                <div className="col-md-2"></div>
                <div className={`col-md-8 d-flex flex-column p-5 rounded border-${props.mode === 'dark' ? 'white' : 'secondary'} bg-${props.mode === 'dark' ? 'secondary' : 'light'} shadow-lg`}>
                    <p className={`pt-1 `}>
                        *Please type carefully, as the number of spaces is crucial for calculating the word count
                    </p>
                    <div className="mb-3 my-3">
                        <label className={`form-label fs-5 `}>{props.heading}</label>
                        <textarea
                            className={`form-control border-${props.mode} resize-none bg-${props.mode === 'dark' ? 'secondary' : 'light'} text-${props.mode === 'dark' ? 'light' : 'dark'} shadow-lg`}
                            id="myText"
                            value={text} // Set value to empty string if text is empty
                            placeholder={'Enter your text'} 
                            rows="4"
                            onChange={OnChange}
                        ></textarea>
                    </div>
                    <div className='d-flex justify-content-between align-content-stretch flex-wrap'>
                        <button type="button" className="btn btn-primary ms-2 me-2 mb-1 py-1 flex-fill" onClick={makeUpCase}>Make UpperCase</button>
                        <button type="button" className="btn btn-primary ms-2 me-2 mb-1 py-1 flex-fill" onClick={makeLwCase}>Make LowerCase</button>
                        <button type="button" className="btn btn-primary ms-2 me-2 mb-1 py-1 flex-fill" onClick={makeCapitalize}>Capitalize</button>
                        <button type="button" className="btn btn-primary ms-2 me-2 mb-1 py-1 flex-fill" onClick={rmExtraSpace}>Remove Extra Space</button>
                        <button type="button" className="btn btn-primary ms-2 me-2 mb-1 py-1 flex-fill" onClick={noOfWords}>Calculate No. Of Words</button>
                        <button type="button" className="btn btn-primary ms-2 me-2 mb-1 py-1 flex-fill" onClick={cpText}>Copy Result</button>
                        <button type="button" className="btn btn-primary ms-2 me-2 mb-1 py-1 flex-fill" onClick={dwText}>Download Text</button>
                        <button type="button" className="btn btn-danger ms-2 me-2 mb-1 py-1 flexgrow-1 flex-fill" onClick={clsScreen}>Clear Screen</button>
                    </div>
                    <div className={`border-${props.mode} container p-3 border bg-${props.mode === 'dark' ? 'secondary' : 'light'} text-${props.mode === 'dark' ? 'light' : 'dark'} shadow my-3 p-3 rounded mt-5`}>
                        <h1>(Real Time) Text Analysis</h1>
                        <div>
                            Your Sentence Contains
                            <p>Words: {result.length === 0 ? 0 : result.split(/\s+/).length} <br />
                                Letters: {result.length} <br />
                                Average Time For Reading: {result.length === 0 ? 0 : (result.split(/\s+/).length * 0.5 / 60).toFixed(2)} minutes</p>
                        </div>
                        <div className={`preview bg-${props.mode === 'dark' ? 'secondary' : 'light'} text-${props.mode === 'dark' ? 'light' : 'dark'} rounded p-1`}>
                            <h2 className={`p-1 text-${props.mode === 'dark' ? 'light' : 'dark'} `}>Preview:</h2>
                            <h6 className={`shadow-sm p-2 m-1  text-${props.mode === 'dark' ? 'light' : 'dark'} bg-${props.mode === 'dark' ? 'dark' : 'light'} rounded border-${props.mode}`}>
                                <br />{result.length === 0 ? "Enter a sentence or some text to see the preview" : result}
                            </h6>
                        </div>
                    </div>
                </div>
                <div className="col-md-2"></div>
            </div>
        </>
    );
}
